<template>
  <div class="bg-white rounded-lg p-10">
    <Loader v-if="loading"/>
    <div v-else>
      <button
          @click="$emitter.emit('open-admin-create-expert-purpose-category-modal')"
          class="mb-5 p-2 font-medium bg-blue-700 hover:bg-blue-800 text-white rounded-lg w-1/12 flex justify-center"
      >
        {{ $lang.app.CREATE }}
      </button>
      <table v-if="expertPurposeCategories" class="table-auto w-full mb-8">
        <thead class="border-solid border">
        <tr>
          <th class="py-3 px-5 border border-slate-300">{{ $lang.app.DENOMINATION }}</th>
          <th class="w-2.5 py-3 px-5 border border-slate-300">{{ $lang.app.BLOCKING }}</th>
          <th class="w-2.5 py-3 px-5 border border-slate-300">{{ $lang.app.MORE }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in expertPurposeCategories" :key="index">
          <td class="py-3 px-5 border border-slate-300">
            {{ item.title }}
          </td>
          <td class="py-3 px-5 border border-slate-300">
            <label class="switch">
              <input
                  type="checkbox"
                  @change="blockToggle($event.target.value, item)"
                  :checked="item.status == modelStatusesGetValueByKey('BLOCKED')"
                  :value="item.status"
              />
              <span class="slider round"></span>
            </label>
          </td>
          <td class="py-3 px-5 table-center border border-slate-300">
            <div class="flex">
              <button class="mx-1" @click="$emitter.emit('open-admin-detail-expert-purpose-category-modal', item)">
                <EyeIcon class="w-6 h-6 text-black"/>
              </button>
              <button class="mx-1" @click="$emitter.emit('open-admin-edit-expert-purpose-category-modal', item)">
                <PencilAltIcon class="w-6 h-6 text-black"/>
              </button>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <Pagination
          :value="pagination.page"
          @change="changePage"
          :limit="pagination.limit"
          :total-records="pagination.totalRecords"
      />
    </div>
    <CreateExpertPurposeCategoryModal @stored="fetchResources"/>
    <DetailExpertPurposeCategoryModal/>
    <EditExpertPurposeCategoryModal @updated="fetchResources"/>
  </div>
</template>

<script>
import Pagination from "../../../components/PaginationOld"
import PaginationMixin from "../../../mixins/paginationMixin"
import CreateExpertPurposeCategoryModal
  from "../../../components/admin/expert-purpose-categories/modals/CreateExpertPurposeCategoryModal";
import DetailExpertPurposeCategoryModal
  from "../../../components/admin/expert-purpose-categories/modals/DetailExpertPurposeCategoryModal";
import EditExpertPurposeCategoryModal
  from "../../../components/admin/expert-purpose-categories/modals/EditExpertPurposeCategoryModal";
import expertPurposeCategoryApi from "../../../api/admin/expertPurposeCategory";
import {getValueByKey as modelStatusesGetValueByKey} from "../../../helpers/constants/modelStatuses";

export default {
  components: {
    CreateExpertPurposeCategoryModal,
    DetailExpertPurposeCategoryModal,
    EditExpertPurposeCategoryModal,
    Pagination,
  },
  mixins: [PaginationMixin],
  data() {
    return {
      loading: false,
      expertPurposeCategories: [],
    };
  },
  created() {
    this.setupPage();
    this.fetchResources();
  },
  watch: {
    '$route.query.page'() {
      this.setupPage()
      this.fetchResources()
    }
  },
  methods: {
    modelStatusesGetValueByKey,
    changePage(value) {
      this.$router.push({
        name: 'AdminExpertPurposeCategoriesList',
        query: { page: value },
      })
    },
    fetchResources() {
      this.loading = true
      expertPurposeCategoryApi
          .list({
            limit: this.pagination.limit,
            page: this.pagination.page,
          })
          .then(res => {
            this.expertPurposeCategories = res.list;
            this.pagination.totalRecords = res.totalRecords;
          })
          .finally(() => {
            this.loading = false
          });
    },
    blockToggle(value, item) {
      if (this.modelStatusesGetValueByKey('BLOCKED') == value) {
        expertPurposeCategoryApi.unblock(item.id).then((res) => {
          item.status = res.status
        })
      } else {
        expertPurposeCategoryApi.block(item.id).then((res) => {
          item.status = res.status
        })
      }
    },
  },
};
</script>
